"use client";

import { useState, useEffect } from "react";
import SimpleBookingCard from "./simple-booking-card";

export default function MobileBookingButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isModalOpen]);

  return (
    <>
      {/* Sticky Reserve Button - Only visible on mobile */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-green-950 border-t-2 border-green-700 px-4 py-3 shadow-2xl">
        <button
          onClick={() => setIsModalOpen(true)}
          className="w-full py-3 px-6 bg-green-600 hover:bg-green-500 text-white font-bold text-lg rounded-lg shadow-lg transition-all flex items-center justify-between"
        >
          <span>Reserve</span>
          <span className="text-sm font-normal">from $405/night</span>
        </button>
      </div>

      {/* Booking Modal - Full screen on mobile */}
      {isModalOpen && (
        <div className="lg:hidden fixed inset-0 z-[100] bg-black bg-opacity-95 overflow-y-auto">
          {/* Modal Header */}
          <div className="sticky top-0 z-10 bg-green-950 border-b-2 border-green-700 px-4 py-4 flex items-center justify-between shadow-lg">
            <h2 className="text-xl font-bold">Book Your Stay</h2>
            <button
              onClick={() => setIsModalOpen(false)}
              className="w-10 h-10 flex items-center justify-center bg-green-800 hover:bg-green-700 rounded-lg transition-colors"
              aria-label="Close booking"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Booking Card Content */}
          <div className="p-4 pb-24">
            <SimpleBookingCard />
          </div>
        </div>
      )}
    </>
  );
}
